export const checkoutClickShowYourGoustoBox = 'checkout_click_show_your_gousto_box'
export const checkoutClickHideYourGoustoBox = 'checkout_click_hide_your_gousto_box'
export const checkoutClickEditOrderLink = 'checkout_click_edit_order_link'
